import axios from "@/plugins/axios";

let url = "/api/v1/roulette/logs";

export const logs = {
    gets(data){
        return axios.get(url, data).then(result => result.data);
    },
    post(data){
        return axios.post(url, data).then(result => result.data);
    },
    confirm(){
        return axios.get(`${url}/confirm`).then(result => result.data);
    }
}
